<template>
  <div class="col-md-12">
    <div class="wrapper-spin spinner-remates-resultados" :class="{ 'd-none': isLoaded }" id="spinner">
      <div class="spin">
        <img src="/images/icons/spin.png" alt="Spinner">
      </div>
    </div>
    <div class="row g-0">
      <!-- FILTERS -->
      <div class="col-12 wrapper-filtros2 bg-darkPrimary btn-fixed fixed-shadow py-2 mb-2 mt-n4"
        :class="{ 'active-fixed': isFixedResultados }" ref="btnFixedResultados">
        <div class="row g-0 flex-wrap align-items-center justify-content-center px-2">
          <div class="d-flex align-items-center justify-content-center my-1 px-0" v-for="tipo in tipos">
            <div :class="{ selected: form.tipo != null && form.tipo.id === tipo.id }"
              @click="form.tipo = form.tipo != null && form.tipo.id === tipo.id ? null : tipo"
              class="btn btn-outline-light bg-hover-primary btn-sm lspace-none w-100 font-ARB px-3 mx-1">
              {{ tipo.nombre }}
            </div>
          </div>
          <div data-bs-toggle="modal" data-bs-target="#modalfiltro2"
            class="btn btn-outline-light bg-hover-primary btn-sm font-ARB rounded-pill d-flex align-items-center rounded-pill mx-1 mx-sm-2 my-1">
            Más filtros
          </div>
        </div>
      </div>
      <!-- END FILTERS -->
      <div class="col-xl-8 order-2 order-xl-1 mt-2 mt-md-0">
        <div class="row g-0">

          <div class="col-12 wrapper-remates" v-if="items.data">
            <div class="row g-0 px-0 px-lg-3 px-xl-0" v-for="(item, key, index) in items.data" :key="key">
              <!--DIA-->
              <div class="w-100 d-flex align-items-center px-3 px-lg-0 mt-2 mb-4">
                <h5 class="h5-sm font-ARB text-lightGray4 text-uppercase text-nowrap pe-3 mb-0">
                  {{ key }}
                </h5>
                <hr class="w-100 border-top-dotted border-dark my-0">
              </div>
              <!--END DIA-->
              <div class="m-auto pb-4 wrapper-remates-banner" v-if="index === 1 && banner.length > 0">
                <div v-if="
                  banner[0].activo === true
                " class="content-info px-3 px-md-0">
                  <div :id="[
                    banner[0].gptId
                      ? banner[0].gptId
                      : 'slide_' + banner[0].id,
                  ]" class="ad_remetes">
                    <!-- SHOW IMAGE -->
                    <div v-if="banner[0].image">
                      <img class="cont-img border border-borders" :src="banner[0].image" :alt="banner[0].nombre" />
                    </div>

                    <!-- ADSERVER IMAGE -->
                    <div v-if="banner[0].gpt">
                      <div ref="ad"></div>
                      <div :id="banner[0].gptId" ref="adGpt"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div :id="'remate-' + remateItem.id" class="w-100 px-0" v-for="remateItem in item" :key="remateItem.id">
                <!-- REMATES LN -->
                <div v-if="remateItem.entidad == 'LN'"
                  class="w-100 card content-remate remate-light shadow flex-row flex-wrap border-0 rounded-0 mx-0 mb-3">
                  <div class="col-12 col-lg-3 order-1 wrapper-feature px-0">
                    <div class="row g-0 h-100 flex-row flex-lg-column">
                      <div class="col-12 col-lg">
                        <div class="row g-0 h-100 flex-row">
                          <div
                            class="col col-lg-4 content-info wrapper-calendar d-flex flex-column justify-content-center align-items-center border-right-dotted border-primary py-2">
                            <h5
                              class="fecha d-flex flex-column justify-content-center align-items-center font-ARB text-primary text-center text-uppercase mb-0">
                              <span class="h2-md">{{ remateItem.fecha.dia_int }}</span>
                              <span class="mt-n1">{{ remateItem.fecha.mes_short }}</span>
                            </h5>
                          </div>
                          <div
                            class="col col-lg-8 content-info d-flex flex-lg-column align-items-center justify-content-between justify-content-lg-center py-2 px-3 mt-lg-0">
                            <h5 class="font-ARB text-lightGray2">{{ remateItem.hora }}</h5>
                            <!-- IS LIVE -->
                            <!--<div data-toggle="modal" @click="modalVideo(remateItem.id)"
                              v-if="remateItem.videoUrls.length > 0 && remateItem.isLive"
                              class="btn btn-sm btn-applePrimary font-ARB text-uppercase text-darkPrimary py-3 px-2">
                              Ver en vivo
                            </div>-->
                            <!-- DIA -->
                            <!--<div class="btn btn-lightPrimary3 btn-sm small cursor-text font-ARB text-uppercase text-darkPrimary py-1 px-2" v-if="remateItem.isLive === false && remateItem.dia === 'hoy'">
                              {{ remateItem.fecha.dia }}
                            </div>-->
                            <div
                              class="btn btn-sm small bg-borders cursor-text text-lightGray4 font-ARB text-uppercase py-1 px-2 mb-0">
                              Finalizado
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- MODALIDAD -->
                      <div class="col mt-auto"  v-if="mod == true">
                        <div class="row h-100 flex-column flex-lg-row">
                          <div
                            class="col-lg-12 content-info wrapper-modalidad d-flex flex-wrap justify-content-center align-items-center py-2" >
                            <div v-for="(mod, i) in remateItem.modalidad" 
                              class="ico-bg ico-bg-lg rounded-circle border border-borders bg-transparent float-left d-flex justify-content-center align-items-center mx-0 mx-md-1 mb-1 mb-lg-0">
                              <img v-bind:src="'/images/icons/modalidad/' + i + '-gray.png'" :alt="i" class="img-fluid">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-5 wrapper-info order-2 border-end-0 mb-auto mb-lg-0 ps-3">
                    <div class="row g-0 d-flex flex-row flex-wrap align-items-center py-2">
                      <h5 class="col h5-sm font-ARB text-lightGray4 w-100 my-0 my-md-1">{{
                        remateItem.ubicacion.provincia }}{{ remateItem.ubicacion.provincia ? "," : "" }} {{
                          remateItem.ubicacion.localidad }}</h5>
                      <p class="p-sm font-AR text-lightGray4 w-100 mb-1"><b>{{ remateItem.especie }}</b> <i
                          v-if="remateItem.destino">- {{ remateItem.destino }}</i></p>
                      <p v-if="remateItem.cantidad && remateItem.cantidad !== '0'"
                        class="p-sm font-AR text-lightGray4 w-100 mb-1"><b>{{ remateItem.cantidad }}</b> <i>Animales</i>
                      </p>
                      <p class="description p-sm lh-small font-AR text-lightGray4 w-100 mt-2 mb-2"
                        v-html="remateItem.resume"></p>
                    </div>
                  </div>
                  <!-- CABAÑAS & CONSIGNATARIOS -->
                  <div
                    v-bind:class="remateItem.tipo === 'Cabañas' && remateItem.cabanas.length > 0 ? 'justify-content-between' : 'justify-content-center'"
                    class="col-12 col-lg-2 order-3 content-img d-flex flex-row flex-lg-column justify-content-lg-center align-items-center px-3 py-2">
                    <!-- CABAÑAS -->
                    <div v-if="remateItem.tipo === 'Cabañas' && remateItem.cabanas.length > 0"
                      class="order-2 order-lg-1 content-cabañas row flex-nowrap g-0 justify-content-end mt-lg-1 pb-lg-3 mb-lg-auto">
                      <div v-for="cabana in remateItem.cabanas" class="col px-1">
                        <img v-bind:src="cabana.image" class="cabanas px-0" alt="cabañas">
                      </div>
                    </div>
                    <!-- CONSIGNATARIO -->
                    <img v-if="remateItem.consignatario.image" v-bind:src="remateItem.consignatario.image"
                      :alt="remateItem.consignatario.nombre" class="img-fluid order-1 order-lg-2 consignatario">
                  </div>
                  <!-- BOTONERA -->
                  <div class="col-12 col-lg-2 order-5 order-lg-4 content-botonera d-lg-flex px-3 px-lg-2 py-2">
                    <div
                      class="row g-0 w-100 align-items-center align-items-md-start justify-content-end justify-content-lg-start">
                      <div
                        class="col-5 col-lg-12 content-media d-flex align-items-center justify-content-start align-items-lg-start justify-content-lg-end py-0 py-lg-1 me-3 me-lg-0">
                        <!--galeria-->
                        <a v-if="remateItem.galeria.length > 0" data-toggle="modal" @click="modalGaleria(remateItem.id)"
                          class="btn btn-outline-primary text-uppercase ico-bg rounded-circle d-flex justify-content-center align-items-center p-1">
                          <img src="/images/icons/share/camera.svg" alt="camara" class="img-fluid deselected">
                          <img src="/images/icons/share/camera-white.svg" alt="camera" class="img-fluid selected">
                        </a>
                        <!--videos-->
                        <a v-if="remateItem.videoUrls.length > 0" data-toggle="modal" @click="modalVideo(remateItem.id)"
                          class="btn btn-outline-primary text-uppercase ico-bg rounded-circle d-flex justify-content-center align-items-center btn-video p-1">
                          <img src="/images/icons/share/video.svg" alt="video" class="img-fluid deselected">
                          <img src="/images/icons/share/video-white.svg" alt="video" class="img-fluid selected">
                        </a>
                        <!--share-->
                        <div class="wrapper-share" @mouseleave="statusOff()">
                          <a
                            class="share btn btn-outline-primary text-uppercase ico-bg rounded-circle d-flex justify-content-center align-items-center p-2">
                            <img src="/images/icons/share/share.svg" alt="share" class="img-fluid deselected">
                            <img src="/images/icons/share/share-white.svg" alt="share" class="img-fluid selected">
                          </a>
                          <!-- Generated markup by the plugin -->
                          <div class="tooltip-container position-absolute">
                            <div class="row g-0 bg-darkPrimary p-1 px-2">
                              <button @click="copy(remateItem.id)"
                                class="col-4 copyLink btn btn-text d-flex align-items-center justify-content-center px-2 py-2">
                                <img src="/images/icons/share/link-white.svg" alt="copy link">
                                <p class="small tooltip-copyLink font-AR text-white bg-dark rounded-sm p-2"
                                  :id="'myCopyLink-' + remateItem.id">Copiado!</p>
                              </button>
                              <a :href="'mailto:direccion@destinatario.com?&subject=LN%20Campo%20Remates&body=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/email-white.svg" alt="email"></a>
                              <a :href="'https://wa.me/?text=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/whatsapp-white.svg" alt="whatsapp"></a>
                              <a :href="'https://twitter.com/intent/tweet?text=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/twitter-white.svg" alt="twitter"></a>
                              <a href="https://www.instagram.com/" target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/instagram-white.svg" alt="instagram"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-7 col-lg-12 content-action d-flex flex-row flex-lg-column align-items-center justify-content-end justify-content-lg-center px-0 mt-lg-auto">
                        <a v-if="remateItem.resultadosFile"
                          class="btn btn-outline-primary btn-sm text-uppercase font-ARB text-nowrap d-block py-2 me-2 me-lg-0 my-0 my-lg-1"
                          :href="remateItem.resultadosFile" target="_blank">
                          Resultados
                        </a>
                        <a class="btn btn-outline-primary btn-sm btn-detalle text-uppercase ico-down-primary font-ARB text-nowrap d-block max-w-124 py-2 pe-4 my-0 my-lg-1"
                          data-bs-toggle="collapse" v-bind:data-bs-target="'#contentDetalle-' + remateItem.id" role="button"
                          aria-expanded="false" v-bind:aria-controls="'contentDetalle-' + remateItem.id">
                          <span>Ver más</span>
                          <span class="d-none ms-n1 pe-2">Ver menos</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- DETALLE -->
                  <div class="col-12 order-4 order-lg-5 wrapper-detalle collapse px-0"
                    v-bind:id="'contentDetalle-' + remateItem.id">
                    <div class="row g-0 border-top border-borders px-3 py-3">
                      <div class="col-12 col-md">
                        <div class="content-info">
                          <h5 v-if="remateItem.consignatario.nombre" class="h5-sm font-AR text-lightGray4 mb-1"><span
                              class="text-primary font-ARB">Consignatario: </span>{{ remateItem.consignatario.nombre }}
                          </h5>
                          <h5 v-if="remateItem.consignatario.email" class="h5-sm font-AR text-lightGray4 mb-1"><span
                              class="text-primary font-ARB">Mail: </span> <a
                              :href="'mailto:' + remateItem.consignatario.email">{{ remateItem.consignatario.email
                              }}</a>
                          </h5>
                          <h5 v-if="remateItem.consignatario.website" class="h5-sm font-AR text-lightGray4 mb-1"><span
                              class="text-primary font-ARB">Website:</span> <a :href="remateItem.consignatario.website"
                              class="hover-unlin">{{ remateItem.consignatario.website }}</a></h5>
                          <h5 v-if="remateItem.consignatario.telefono" class="h5-sm font-AR text-lightGray4 mb-1"><span
                              class="text-primary font-ARB">Teléfonos:</span>
                            {{ remateItem.consignatario.telefono }}</h5>
                          <h5 v-if="remateItem.martilleros"
                            class="h5-sm content-martilleros font-AR text-lightGray4 mt-4">
                            <span class="text-primary font-ARB d-block">Martilleros:</span>
                            <span v-html="remateItem.martilleros"></span>
                          </h5>
                          <h5 class="description h5-sm font-AR text-lightGray4 mt-4" v-html="remateItem.descripcion">
                          </h5>
                        </div>
                      </div>
                      <!-- DESTACADOS -->
                      <div v-if="remateItem.bannerDestacado"
                        class="col-12 col-md-5 wrapper-destacado pt-3 pt-md-0 px-0 px-md-3">
                        <div class="cont-img pt-0 ms-auto me-auto me-md-0">
                          <img v-bind:src="remateItem.bannerDestacado.image" :alt="remateItem.bannerDestacado.nombre">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END REMATES LN -->
                <!-- REMATES LR -->
                <div v-if="remateItem.entidad == 'LR'"
                  class="w-100 card content-remate remate-light shadow flex-row flex-wrap border-0 rounded-0 mx-0 mb-3">
                  <div class="col-12 col-lg-3 order-1 wrapper-feature px-0">
                    <div class="row g-0 h-100 flex-row flex-lg-column">
                      <div class="col-12 col-lg">
                        <div class="row g-0 h-100 flex-row">
                          <div
                            class="col col-lg-4 content-info wrapper-calendar d-flex flex-column justify-content-center align-items-center border-right-dotted border-primary py-2">
                            <h5
                              class="fecha d-flex flex-column justify-content-center align-items-center font-ARB text-primary text-center text-uppercase mb-0">
                              <span class="h2-md">{{ remateItem.fecha.dia_int }}</span>
                              <span class="mt-n1">{{ remateItem.fecha.mes_short }}</span>
                            </h5>
                          </div>
                          <div
                            class="col col-lg-8 content-info d-flex flex-lg-column align-items-center justify-content-between justify-content-lg-center px-3 py-2 mt-lg-0">
                            <h5 class="font-ARB text-lightGray2 mb-0 mb-lg-2">{{ remateItem.hora }}</h5>
                            <div
                              class="btn btn-sm small bg-borders cursor-text text-lightGray4 font-ARB text-uppercase py-1 px-2 mb-0">
                              Finalizado
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-5 wrapper-info order-2 border-end-0 mb-auto mb-lg-0 ps-3">
                    <div class="row g-0 d-flex flex-row flex-wrap align-items-center py-2">
                      <h5 class="col h5-sm font-ARB text-lightGray4 w-100 my-0 my-md-1">{{
                        remateItem.ubicacion.provincia }}{{ remateItem.ubicacion.provincia ? "," : "" }} {{
                          remateItem.ubicacion.localidad }}</h5>
                      <p v-if="remateItem.especie || remateItem.destino"
                        class="p-sm font-AR text-lightGray4 w-100 mb-1"><b v-if="remateItem.especie">{{
                          remateItem.especie }}</b> <i v-if="remateItem.destino">- {{ remateItem.destino }}</i></p>
                      <p v-if="remateItem.cantidad && remateItem.cantidad !== '0'"
                        class="p-sm font-AR text-lightGray4 w-100 mb-1"><b>{{ remateItem.cantidad }}</b> <i>Animales</i>
                      </p>
                      <p class="description p-sm lh-small font-AR text-lightGray4 w-100 mt-2 mb-2"
                        v-html="remateItem.resume"></p>
                    </div>
                  </div>
                  <!-- BOTONERA -->
                  <div class="col-12 col-lg-2 order-5 order-lg-4 content-botonera d-lg-flex px-3 px-lg-2 py-2 ms-auto">
                    <div
                      class="row g-0 w-100 align-items-center align-items-md-start justify-content-end justify-content-lg-start">
                      <div
                        class="col-5 col-lg-12 content-media d-flex align-items-center justify-content-start align-items-lg-start justify-content-lg-end py-0 py-lg-1 me-3 me-lg-0">
                        <!--share-->
                        <div class="wrapper-share" @mouseleave="statusOff()">
                          <a
                            class="share btn btn-outline-primary text-uppercase ico-bg rounded-circle d-flex justify-content-center align-items-center p-2">
                            <img src="/images/icons/share/share.svg" alt="share" class="img-fluid deselected">
                            <img src="/images/icons/share/share-white.svg" alt="share" class="img-fluid selected">
                          </a>
                          <!-- Generated markup by the plugin -->
                          <div class="tooltip-container position-absolute">
                            <div class="row g-0 bg-darkPrimary p-1 px-2">
                              <button @click="copy(remateItem.id)"
                                class="col-4 copyLink btn btn-text d-flex align-items-center justify-content-center px-2 py-2">
                                <img src="/images/icons/share/link-white.svg" alt="copy link">
                                <p class="small tooltip-copyLink font-AR text-white bg-dark rounded-sm p-2"
                                  :id="'myCopyLink-' + remateItem.id">Copiado!</p>
                              </button>
                              <a :href="'mailto:direccion@destinatario.com?&subject=LN%20Campo%20Remates&body=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/email-white.svg" alt="email"></a>
                              <a :href="'https://wa.me/?text=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/whatsapp-white.svg" alt="whatsapp"></a>
                              <a :href="'https://twitter.com/intent/tweet?text=https://lncampo.lanacion.com.ar/remates%23remate-' + remateItem.id"
                                target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/twitter-white.svg" alt="twitter"></a>
                              <a href="https://www.instagram.com/" target="_blank"
                                class="col-4 d-flex align-items-center justify-content-center px-2 py-2"><img
                                  src="/images/icons/share/instagram-white.svg" alt="instagram"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-7 col-lg-12 content-action d-flex flex-row flex-lg-column align-items-center justify-content-end justify-content-lg-center px-0 mt-lg-auto">
                        <a v-if="remateItem.resultadosFile"
                          class="btn btn-outline-primary btn-sm text-uppercase font-ARB text-nowrap d-block py-2 me-2 me-lg-0 my-0 my-lg-1"
                          :href="remateItem.resultadosFile" target="_blank">
                          Resultados
                        </a>
                        <a class="btn btn-outline-primary btn-sm btn-detalle text-uppercase ico-down-primary font-ARB text-nowrap d-block max-w-124 py-2 pe-4 my-0 my-lg-1"
                          data-bs-toggle="collapse" v-bind:data-bs-target="'#contentDetalle-' + remateItem.id" role="button"
                          aria-expanded="false" v-bind:aria-controls="'contentDetalle-' + remateItem.id">
                          <span>Ver más</span>
                          <span class="d-none ms-n1 pe-2">Ver menos</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <!-- DETALLE -->
                  <div class="col-12 order-4 order-lg-5 wrapper-detalle collapse px-0"
                    v-bind:id="'contentDetalle-' + remateItem.id">
                    <div class="row g-0 border-top border-borders px-3 py-3">
                      <div class="col-12 col-md">
                        <div class="content-info">
                          <h5 v-if="remateItem.consignatario && remateItem.consignatario.nombre"
                            class="h5-sm font-AR text-lightGray4 mt-0 mb-5"><span
                              class="text-primary font-ARB">Consignatario: </span>
                            {{ remateItem.consignatario.nombre }}</h5>

                          <div class="source d-flex align-items-center">
                            <h5 class="small font-ARB text-uppercase text-lightGray pe-3 mb-0">Fuente:</h5>
                            <img src="images/brands/rural.png" class="img-fluid max-w-80" alt="Rural">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END REMATES LR -->
              </div>
            </div>
          </div>

          <!-- Pagination controls -->
          <hr class="w-100 border-top-dotted border-dark mt-3 mb-4" />
          <div v-if="idParam === true" class="w-100 mb-3">
            <button tipo="button" @click="reset()"
              class="btn btn-outline-primary btn-sm font-ARB rounded-pill d-flex align-items-center rounded-pill mx-auto my-0">
              Ver todos los remates
            </button>
          </div>
          <custom-pagination :items="items" @getRemates="getRemates" />
          <!-- Pagination controls -->
          <!-- NO RESULTS-->
          <div class="col-12 wrapper-filtrosNone bg-white shadow p-3" v-if="items.data.length === 0">
            <div class="card rounded-0 border border-primary bg-lightPrimary2 py-5 py-lg-5 m-0">
              <div class="card-body d-flex flex-column align-items-center justify-content-center py-5">
                <h4 class="h4-sm font-ARB text-primary mb-3 mb-lg-4">Tu búsqueda no ha dado resultados.</h4>
                <button tipo="button" @click="reset()"
                  class="btn btn-outline-primary btn-sm font-ARB rounded-pill d-flex align-items-center rounded-pill my-0">
                  Limpiar Filtros
                </button>
              </div>
            </div>
          </div>
          <!--END NO RESULTS-->
          <!-- CONTENIDO PUBLICITARIO DK -->
          <div v-if="publicidad === true" class="col-md-12 wrapper-content-publi d-md-block px-0 px-md-3 py-0">
            <div class="bg-light" v-if="bannerpaginacion.length > 0">
              <div class="m-auto pb-4 wrapper-remates-banner" :class="{ 'd-block': bannerpaginacion.length > 0 }">
                <div v-if="bannerpaginacion[0].activo === true" class="content-info px-3 px-md-0">
                  <div :id="[bannerpaginacion[0].gptId ? bannerpaginacion[0].gptId : 'slide_' + bannerpaginacion[0].id]"
                    class="ad_paginacion">
                    <img v-if="bannerpaginacion[0].image" class="cont-img border border-borders"
                      :src="bannerpaginacion[0].image" :alt="bannerpaginacion[0].nombre" />
                    <!-- ADSERVER IMAGE -->
                    <div v-if="bannerpaginacion[0].gpt">
                      <div ref="ad"></div>
                      <div :id="bannerpaginacion[0].gptId" ref="adGpt"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END CONTENIDO PUBLICITARIO -->
        </div>
      </div>
      <div class="col-xl-4 order-1 order-xl-2 wrapper-filtros2 border-borders ps-lg-4 ps-xl-5 pe-0">
        <div class="row g-0 bg-white wrapper-content-modal modal shadow-md fade px-0 px-lg-3 py-0 py-lg-4"
          id="modalfiltro2" tabindex="-1" role="dialog" aria-labelledby="modalfiltroTitle" aria-hidden="true">
          <div class="modal-dialog h-100 mx-0 my-0 modal-full" role="document">
            <div class="modal-content line-down h-100 border-0 pt-0 pt-md-4 pt-lg-0">
              <!-- CLOSE BUTTON MOBIILE -->
              <button tipo="button" class="close position-absolute text-white full-opacity d-block bg-transparent border-0" data-bs-dismiss="modal"
                aria-label="Close">
                <a aria-hidden="true"
                  class="btn btn-outline-primary ico-bg rounded-circle d-flex justify-content-center align-items-center p-0 mx-1">
                  <span class="w-50">
                    <svg viewBox="0 0 17.02 22.249">
                      <g transform="translate(-8.44 -5.603)">
                        <path d="M11.424.247.387,19.221" transform="matrix(0.966, 0.259, -0.259, 0.966, 13.766, 5.797)"
                          fill="none" stroke="#008561" stroke-width="1.5" />
                        <path d="M14.427,0,0,15.028" transform="translate(9.438 23.941) rotate(-90)" fill="none"
                          stroke="#008561" stroke-width="1.5" />
                      </g>
                    </svg>
                  </span>
                </a>
              </button>
              <!-- END CLOSE BUTTON MOBILE -->
              <!-- FILTERS -->
              <div class="modal-body p-0">
                <div class="card line-down rounded-sm border-0 w-100 px-0 m-0">
                  <div
                    class="card-header d-flex justify-content-between align-items-center text-white bg-primary border-primary py-3 py-xl-2">
                    <h5 class="h5-md font-SSB mb-0">
                      Filtros
                    </h5>
                  </div>
                  <div class="card-body green p-0">
                    <ul class="list-group list-group-flush wrapper-modalidad">
                      <!-- TIPOS DE REMATE -->
                      <li class="list-group-item px-3 px-xl-4 py-3">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-2" for="place">Remates</p>
                          <div class="row g-0 justify-content-between align-items-center">

                            <!-- TIPOS DE REMATE LOOP -->
                            <div class="w-50 px-1 my-1" v-for="tipo in tipos">
                              <div :class="{ selected: form.tipo != null && form.tipo.id === tipo.id }"
                                @click="form.tipo = form.tipo != null && form.tipo.id === tipo.id ? null : tipo"
                                class="btn btn-outline-lightPrimary2 border-primary text-primary btn-sm lspace-none w-100 font-ARB py-2 px-3">
                                {{ tipo.nombre }}
                              </div>
                            </div>
                            <!-- END TIPOS DE REMATE LOOP -->

                          </div>
                        </div>
                      </li>
                      <!-- END TIPOS DE REMATE -->

                      <!-- FECHA -->
                      <li class="list-group-item px-3 px-xl-4 py-3">
                        <div class="content-info w-100 px-2">
                          <p class="font-ARB p-sm text-lightGray4 mb-2" for="place">Buscar por fecha</p>
                          <div class="row g-0 justify-content-between align-items-center">
                            <!-- DESDE -->
                            <div class="w-50 px-1 my-1">
                              <div
                                class="btn btn-outline-lightPrimary2 border-primary text-primary btn-sm text-uppercase w-100 font-ARB py-0 px-3">
                                <VueDatePicker v-model="form.desde" placeholder="Desde" :min-date="minDate" locale="es"
                                  auto-apply hide-offset-dates partial-flow position="left" month-name-format="long"
                                  :enable-time-picker="false" :format="formatDate" />
                              </div>
                            </div>
                            <!-- END DESDE -->
                            <!-- HASTA -->
                            <div class="w-50 px-1 my-1">
                              <div
                                class="btn btn-outline-lightPrimary2 border-primary text-primary btn-sm text-uppercase w-100 font-ARB py-0 px-3">
                                <VueDatePicker v-model="form.hasta" placeholder="Hasta" :min-date="minDate" locale="es"
                                  auto-apply hide-offset-dates partial-flow position="left" month-name-format="long"
                                  :enable-time-picker="false" :format="formatDate" />
                              </div>
                            </div>
                            <!-- END HASTA -->
                          </div>
                        </div>
                      </li>
                      <!-- END FECHA -->

                      <!-- MODALIDAD -->
                      <li class="list-group-item content-modalidad px-3 px-xl-4 py-3">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-2" for="place">Modalidad</p>
                          <div class="row g-0 justify-content-between align-items-center">
                            <!-- MODALIDAD LOOP -->
                            <div class="col-4 p-1" v-for="(modalidad, idx) in modalidades">
                              <div :class="{ selected: form.modalidad.includes(modalidad.id) }"
                                @click="setModalidad(modalidad.id)"
                                class="btn btn-outline-lightPrimary2 border-primary text-primary btn-sm small lspace-none w-100 text-uppercase font-ARB text-nowrap d-flex flex-column p-2">
                                <div class="cont-img bg-transparent mb-2 mt-1">
                                  <img
                                    v-bind:src="form.modalidad.includes(modalidad.id) ? '/images/icons/modalidad/' + modalidad.slug + '-white.png' : '/images/icons/modalidad/' + modalidad.slug + '.png'"
                                    v-bind:alt="modalidad.nombre">
                                </div>
                                <span class="modality-responsive">{{ modalidad.nombre }}</span>
                              </div>
                            </div>
                            <!-- END MODALIDAD LOOP -->
                          </div>
                        </div>
                      </li>
                      <!-- END MODALIDAD -->

                      <!-- CONSIGNATARIOS SELECT-->
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-3">
                            Consignatarios
                          </p>
                          <multiselect :options="consignatarios" :selectedItems="form.consignatario" :placeholder="'consignatarios'" trackBy="nombre"></multiselect>
                        </div>
                      </li>
                      <!-- END CONSIGNATARIOS -->

                      <!-- CABAÑAS SELECT -->
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5" v-if="
                        form.tipo != null && form.tipo.nombre == 'Cabañas'
                      ">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-3">
                            Cabañas
                          </p>
                          <multiselect :options="cabanas" :selectedItems="form.cabana" :placeholder="'cabañas'" trackBy="nombre"></multiselect>
                        </div>
                      </li>
                      <!--UBICACIONES SELECT-->
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-3">
                            Ubicación
                          </p>
                          <multiselect :options="ubicaciones" :selectedItems="form.ubicacion" :placeholder="'ubicaciones'" trackBy="text"></multiselect>
                        </div>
                      </li>
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-2">
                            Especie
                          </p>
                          <custom-select :options="especies" @update:selectedOption="form.especie = $event" :is-resetting="isResetting" @isResetting="resetValues" track-by="nombre" size="small"></custom-select>
                        </div>
                      </li>
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5" v-if="this.form.especie.id != 0">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-2">
                            Destino
                          </p>
                          <custom-select :options="destinos" @update:selectedOption="form.destino = $event" size="small" track-by="nombre"></custom-select>
                        </div>
                      </li>
                      <li class="list-group-item px-3 px-xl-4 pt-3 pb-5" v-if="this.form.especie.id != 0">
                        <div class="content-info w-100 px-2">
                          <p class="p-sm font-ARB text-lightGray4 mb-2">Raza</p>
                          <custom-select :options="razas" @update:selectedOption="form.raza = $event" size="small" track-by="nombre"></custom-select>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="card-footer bg-primary d-block border-0">
                    <div class="d-flex justify-content-between align-items-center">
                      <button tipo="button" @click="cerrarFiltro('#modalfiltro2')"
                        class="btn btn-outline-light btn-sm font-ARB rounded-pill d-flex align-items-center rounded-pill m-1">
                        Aplicar Filtros
                      </button>
                      <button tipo="button" @click="reset()"
                        class="btn btn-outline-light btn-sm font-ARB rounded-pill d-flex align-items-center rounded-pill m-1">
                        Limpiar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END FILTERS -->
            </div>
          </div>
        </div>
        <!-- AD ASIDE RIGHT -->
        <div class="col-md-12 wrapper-content-publi aside px-0 py-0">
          <div class="m-auto pb-4 wrapper-remates-banner" v-if="bannerasideright.length > 0"
            :class="{ 'd-block': bannerasideright.length > 0 }">
            <div v-if="bannerasideright[0].activo === true" class="content-info px-3 px-md-0">
              <div :id="[bannerasideright[0].gptId ? bannerasideright[0].gptId : 'slide_' + bannerasideright[0].id]"
                class="ad_aside_filtro">
                <img v-if="bannerasideright[0].image" class="cont-img border border-borders"
                  :src="bannerasideright[0].image" :alt="bannerasideright[0].nombre" />
                <!-- ADSERVER IMAGE -->
                <div v-if="bannerasideright[0].gpt">
                  <div ref="ad"></div>
                  <div :id="bannerasideright[0].gptId" ref="adGpt"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END AD ASIDE RIGHT  -->
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper } from 'swiper/bundle';

export default {
  props: [
    'remates',
    'consignatarios',
    'ubicaciones',
    'especies',
    'destinos',
    'razas',
    'cabanas',
    'tipos',
    "modalidades",
    "publicidad",
    "banner",
    "bannerasideright",
    "bannerpaginacion",
    'receivedOffsetValue'
  ],
  methods: {
    cerrarFiltro(modal) {
      //resetea el contenedor de filtros
      this.isFixedResultados = !this.isFixedResultados
      //y cierra el modal
      $(modal).modal("hide");
    },
    statusOff() {
      const tooltip = document.querySelector('.tooltip-copyLink');
      tooltip.classList.remove('anima');
    },
    copy(id) {
      const copyText = `https://lncampo.lanacion.com.ar/remates#remate-${id}`;
      navigator.clipboard.writeText(copyText);
      const tooltip = document.getElementById(`myCopyLink-${id}`);
      tooltip.classList.add('anima');
      setTimeout(() => {
        tooltip.classList.remove('anima');
      }, 1500);
    },
    modalRemates(id) {
      axios.get(`/modal_remates/${id}/remate`)
        .then(response => {
          $('#modalWindowRemates').html(response.data);
          $(`#modalRemates-${id}`).modal('show');
        });
    },
    modalVideo(id) {
      axios.get(`/modal_remates/${id}/video`)
        .then(response => {
          $('#modalWindowVideo').html(response.data);
          $(`#modalVideo-${id}`).modal('show');
        });
    },
    modalGaleria(id) {
      axios.get(`/modal_remates/${id}/galeria`)
        .then(response => {
          $('#modalWindowGaleria').html(response.data);
          $(`#modalGaleria-${id}`).modal('show').on('shown.bs.modal', () => {
            const thumbs = new Swiper('.sliderThumbs', {
              spaceBetween: 10,
              slidesPerView: 4,
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
            });
            console.log('Thumbs', thumbs);
            const swiper = new Swiper('.sliderContent', {
              spaceBetween: 10,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              thumbs: {
                swiper: thumbs,
              },
            });
            console.log('Swiper loaded!');
          });
        });
    },
    setModalidad(id) {
      const index = this.form.modalidad.indexOf(id);
      if (index !== -1) {
        this.form.modalidad.splice(index, 1);
      } else {
        this.form.modalidad.push(id);
      }
    },
    totaldia(dia) {
      return this.items.filter(item => item.dia === dia).length;
    },
    labelUbicacion({ provincia, localidad }) {
      return `${provincia}, ${localidad}`;
    },
    labelGeneric({ nombre }) {
      return nombre;
    },
    removeTag(totales, tag) {
      const index = totales.indexOf(tag);
      if (index !== -1) {
        totales.splice(index, 1);
      }
    },
    submit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.submitted = true;
      }
    },
    resetValues: function(){
      //recibe el flag del componente hijo para resetear valores dentro del mismo
      this.isResetting = false;
    },
    reset() {
      this.form = {
        tipo: null,
        modalidad: [],
        online: false,
        presencial: false,
        televisada: false,
        consignatario: [],
        ubicacion: [],
        cabana: [],
        especie: this.especies[0],
        destino: this.destinos[0],
        raza: this.razas[0],
        desde: null,
        hasta: null,
        idParam: false,
      };
      this.isResetting = true;
    },
    getRemates(remateId, page) {
      //Si no se le pasa número de página, el valor por defecto será 1
      page = page || 1
      $('#spinner').removeClass('d-none');
      axios.get('/api/resultados', {
        params: {
          page,
          tipo: this.form.tipo?.id || null,
          consignatario: this.form.consignatario.map(c => c.id) || null,
          especie: this.form.especie?.id || null,
          destino: this.form.destino?.id || null,
          raza: this.form.raza?.id || null,
          ubicacion: this.form.ubicacion.map(u => u.id) || null,
          modalidad: this.form.modalidad,
          cabanas: this.form.cabana.map(c => c.id) || null,
          desde: this.form.desde,
          hasta: this.form.hasta,
        },
      }).then(response => {
        this.items = response.data;
        $('#spinner').addClass('d-none');
      });
    },
    getUbicaciones(query) {
      axios.get('/api/ubicacion', { params: { search: query } })
        .then(response => {
          this.ubicaciones = response.data.data;
        });
      console.log(this.ubicaciones);
    },
    //revisa scroll y fijar contenedor de filtros
    checkScroll() {
      //siempre y cuando haya resultados, que se active la función
      if (this.items.pagination.total > 0) {
        this.isFixedResultados = window.scrollY > this.btnFixOffsetTwo;
      }
    },
    //formatea fecha
    formatDate(date) {
      if (!date) return '';

      const day = date.getDate().toString().padStart(2, '0');
      const month = date.toLocaleString('default', { month: 'long' });
      const finalMonth = month.charAt(0).toUpperCase() + month.slice(1);
      const year = date.getFullYear();

      return `${day} ${finalMonth} ${year}`;
    }
  },
  data() {
    return {
      currentDate: new Date(),
      dateColor: '#15906C',
      hasFilters: false,
      items: this.remates,
      idParam: false,
      submitted: false,
      trackBy: 'nombre',
      initialValues: [''],
      form: {
        tipo: null,
        modalidad: [],
        online: false,
        presencial: false,
        televisada: false,
        consignatario: [],
        ubicacion: [],
        cabana: [],
        especie: this.especies[0],
        destino: this.destinos[0],
        raza: this.razas[0],
        desde: null,
        hasta: null,
      },
      minDate: null,
      isLoaded: false,
      isFixedResultados: false,
      btnFixOffsetTwo: this.receivedOffsetValue,
      isResetting: false,
    };
  },
  mounted() {
    //fija contenedor de filtros
    window.addEventListener('scroll', this.checkScroll);

    //fechas para datepicker
    const today = new Date(); // Fecha de hoy
    const calculatedMinDate = new Date(
      today.getFullYear(),
      today.getMonth() - 6,
      today.getDate()
    );
    this.minDate = calculatedMinDate

    if (window.location.search) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      for (const i in params) {
        if (i === 'tipo') {
          this.form.tipo = { id: parseInt(params[i], 10) };
        }
        if (i === 'desde') {
          this.form.desde = params[i];
        }
        if (i === 'hasta') {
          this.form.hasta = params[i];
        }
        if (i === 'consignatario[]') {
          this.form.consignatario = this.consignatarios.filter(c =>
            urlSearchParams.getAll('consignatario[]').includes(c.id.toString())
          );
        }
        if (i === "id") {
          this.idParam = true;
        } else {
          this.idParam = false;
        }
      }
      console.log('Form after params:', this.form);
    }
    this.isLoaded = true;
  },
  watch: {
    initialValues: {
      immediate: true,
      handler(values) {
        this.form.consignatario = this.consignatarios.filter(x => values.includes(x[this.trackBy]));
        this.form.cabana = this.cabanas.filter(x => values.includes(x[this.trackBy]));
        this.form.ubicacion = this.ubicaciones.filter(x => values.includes(x[this.trackBy]));
      },
    },
    receivedOffsetValue(newVal) {
      this.btnFixOffsetTwo = newVal;
    },
    form: {
      deep: true,
      handler() {
        this.getRemates();
      },
    }
  },
  created() {
    this.btnFixOffsetTwo = this.receivedOffsetValue;
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.checkScroll);
  },
};

</script>
